import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as amplitude from "@amplitude/analytics-browser";

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track specific route-based events
    const path = location.pathname;

    if (path === "/") {
      amplitude.track("Home page viewed");
    }

    if (path.startsWith("/auth")) {
      amplitude.track("Authentication page viewed");
    }

    if (path.startsWith("/my-account")) {
      amplitude.track("Account page viewed");
    }
  }, [location]);

  return null;
}

export const useAnalyticsTracker = () => {
  const trackEvent = (
    eventName: string,
    eventProperties?: Record<string, any>
  ) => {
    amplitude.track(eventName, eventProperties);
  };

  return { trackEvent };
};
